<template>
    <v-app id="inspire">
        <div class="shift-layout-wrap">
            <div class="details-header top-header-shift">
                <div class="details-header-back">
                    <p class="header-title title-name">Shift ID: <span class="title-response headline">{{this.$route.params.id}}</span>
                    </p>
                    <v-btn class="header-btn-back mr-0 mb-3" @click="$router.go(-1)">
                        <v-icon class="header-btn-back-icon">navigate_before</v-icon>
                        Back
                    </v-btn>
                </div>
            </div>
            <div>
                <!-- Header boxes -->
                <v-container class="grid-list-lg px-0 pt-0 container--fluid">
                    <v-layout class="wrap xs12 bottom-card-space">
                        <!-- Name -->
                            <v-flex md3 sm6 xs12 flex-grow-1>
                                <v-card>
                                    <div class="img-div-header-box img-header-box-name">
                                        <v-icon large>account_circle</v-icon>
                                    </div>
                                    <div class="title-div-header-box">
                                        <p class="text-uppercase">Staff Member</p>
                                        <router-link
                                            v-if="this.items.length > 0"
                                            v-bind:to="'/staff/' + items[0].employee_id + '/show'"
                                            class="remove-underline">
                                            <h4 class="employee-name">{{items[0].name}}</h4>
                                        </router-link>
                                    </div>
                                </v-card>
                            </v-flex>
                            <!-- Total Shift Duration -->
                            <v-flex md3 sm6 xs12 flex-grow-1>
                                <v-card>
                                    <div class="img-div-header-box img-header-box-duration">
                                        <v-icon large>access_time</v-icon>
                                    </div>
                                    <div class="title-div-header-box">
                                        <p class="text-uppercase">Work Hours<p>
                                        <h4 v-if="items.length > 0" :class="{'error--text': String(items[0].duration_time).charAt(0) === '-'}">{{items[0].duration_time}}</h4>
                                    </div>
                                </v-card>
                            </v-flex>
                            <!-- Total Distance -->
                            <v-flex md3 sm6 xs12 flex-grow-1>
                                <v-card>
                                    <div class="img-div-header-box img-header-box-distance">
                                        <v-icon large>local_cafe</v-icon>
                                    </div>
                                    <div class="title-div-header-box">
                                        <p class="text-uppercase">Break Hours<p>
                                        <h4 v-if="items.length > 0" :class="{'error--text': String(items[0].duration_time_break).charAt(0) === '-'}">{{items[0].duration_time_break}}</h4>
                                    </div>
                                </v-card>
                            </v-flex>
                            <!-- Shift Renvenue -->
                            <v-flex md3 sm6 xs12 flex-grow-1>
                                <v-card>
                                    <div class="img-div-header-box img-header-box-renvenue">
                                        <v-icon large>directions_car</v-icon>
                                    </div>
                                    <div class="title-div-header-box">
                                        <p class="text-uppercase">Shift Distance<p>
                                        <span class="caption">Excluding Break</span>    
                                        <h4 v-if="items.length > 0">{{items[0].company_mileage + items[0].private_mileage}}</h4>
                                    </div>
                                </v-card>
                            </v-flex>
                    </v-layout>
                </v-container>

                <!-- Start Shift Info -->
                <v-card class="mt-6 elevation-3">
                    <h3 class="px-4 py-6">Start Shift Info</h3>
                    <v-divider></v-divider>
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        :loading="loading"
                        loader-height="2"
                        hide-default-header
                        hide-default-footer
                        mobile-breakpoint="100"
                    >
                        <template v-slot:item="{item}">
                            <tr>
                                <td>Vehicle</td>
                                <td>
                                    <strong v-if="!no_data.includes(item.start_company_vehicle)">
                                        <span v-if="item.start_company_vehicle === 1">Company</span>
                                        <span v-if="item.start_company_vehicle === 0">Personal</span>
                                    </strong>
                                    <em v-else class="grey--text">No Data</em>
                                </td>
                                <td>Start Shift Time</td>
                                <td>
                                    <strong v-if="!no_data.includes(item.start_time)">
                                        {{onlyTime(item.start_time)}}
                                    </strong>
                                    <em v-else class="grey--text">No Data</em>
                                </td>
                            </tr>
                            <tr>
                                <td>Odometer Shift Start</td>
                                <td>
                                    <strong v-if="!no_data.includes(item.start_odometer)">
                                        {{item.start_odometer}}
                                    </strong>
                                    <em v-else class="grey--text">No Data</em>
                                </td>
                                <td>Start Shift Date</td>
                                <td>
                                    <strong v-if="!no_data.includes(item.start_time)">
                                        {{onlyDate(item.start_time)}}
                                    </strong>
                                    <em v-else class="grey--text">No Data</em>
                                </td>
                            </tr>
                            <tr>
                                <td>Start Shift Notes</td>
                                <td>
                                    <strong v-if="!no_data.includes(item.start_note)">
                                        {{item.start_note}}
                                    </strong>
                                    <em v-else class="grey--text">No Data</em>
                                </td>
                                <td></td>
                                <td></td>
                            </tr>
                        </template>
                        <template v-if="items.length > 0" v-slot:footer>
                            <v-divider></v-divider>
                            <v-layout class="py-2 px-6">
                                <v-spacer></v-spacer>
                                <v-btn text large background="#e0f7fa" color="#00838F" @click="editStartShiftModal()">Edit</v-btn>
                            </v-layout>
                        </template>
                    </v-data-table>                
                </v-card>

                <!-- End Shift Info -->
                <v-card class="mt-6 elevation-3">
                    <h3 class="px-4 py-6">End Shift Info</h3>
                    <v-divider></v-divider>
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        :loading="loading"
                        loader-height="2"
                        hide-default-header
                        hide-default-footer
                        mobile-breakpoint="100"
                    >
                        <template v-slot:item="{item}">
                            <tr>
                                <td>Odometer Shift End</td>
                                <td>
                                    <strong v-if="!no_data.includes(item.end_odometer)">
                                        {{item.end_odometer}}
                                    </strong>
                                    <em v-else class="grey--text">No Data</em>
                                </td>
                                <td>End Shift Time</td>
                                <td>
                                    <strong v-if="!no_data.includes(item.end_time)">
                                        {{onlyTime(item.end_time)}}
                                    </strong>
                                    <em v-else class="grey--text">No Data</em>
                                </td>
                            </tr>
                            <tr>
                                <td>End Shift Notes</td>
                                <td>
                                    <strong v-if="!no_data.includes(item.end_note)">
                                        {{item.end_note}}
                                    </strong>
                                    <em v-else class="grey--text">No Data</em>
                                </td>
                                <td>End Shift Date</td>
                                <td>
                                    <strong v-if="!no_data.includes(item.end_time)">
                                        {{onlyDate(item.end_time)}}
                                    </strong>
                                    <em v-else class="grey--text">No Data</em>
                                </td>
                            </tr>
                        </template>
                        <template v-if="items.length > 0" v-slot:footer>
                            <v-divider></v-divider>
                            <v-layout class="py-2 px-6">
                                <v-spacer></v-spacer>
                                <v-btn text large background="#e0f7fa" color="#00838F" @click="editEndShiftModal()">Edit</v-btn>
                             </v-layout>
                        </template>
                    </v-data-table>                
                </v-card>

                <break-info 
                    v-if="items.length > 0"
                    :breaks="breaks" 
                    :shift="this.items"
                    :loading="loading" 
                    @reload="getDataFromApi"
                ></break-info>

                <!-- Edit Start Shift Info -->
                <v-dialog v-if="editStartShiftDialog" v-model="editStartShiftDialog" max-width="500px" persistent>
                    <v-card class="pa-4">
                        <div>
                            <v-card-title>
                                <h2 class="title">Edit Start Shift Info</h2>
                            </v-card-title>

                            <div class="py-4 px-6">
                                <v-autocomplete
                                    :items="vehicle"
                                    label="Vehicle*"
                                    item-text="text"
                                    item-value="value"
                                    v-model="editStartShiftData.start_company_vehicle"
                                    placeholder="Please Select"
                                    :error-messages="errors($v.editStartShiftData.start_company_vehicle) || server_errors.start_company_vehicle"
                                    @blur="$v.editStartShiftData.start_company_vehicle.$touch()"
                                    @focus="resetServerValidation"
                                >
                                </v-autocomplete>
                                <v-text-field
                                    label="Odometer Shift Start*"
                                    v-model="editStartShiftData.start_odometer"
                                    placeholder="Please Enter"
                                    maxlength="4"
                                    v-mask="'####'"
                                    :error-messages="errors($v.editStartShiftData.start_odometer) || server_errors.start_odometer"
                                    @blur="$v.editStartShiftData.start_odometer.$touch()"
                                    @focus="resetServerValidation"
                                ></v-text-field>
                                <v-menu
                                    ref="menu1"
                                    :close-on-content-click="false"
                                    v-model="menu1"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            class="scale-icon mb-2"
                                            v-on="on"
                                            v-model="editStartShiftData.start_time"
                                            label="Start time*"
                                            prepend-icon="access_time"
                                            readonly
                                            placeholder="Please Enter"
                                            :error-messages="errors($v.editStartShiftData.start_time) || server_errors.start_time"
                                            @blur="$v.editStartShiftData.start_time.$touch()"
                                            @focus="resetServerValidation"
                                        ></v-text-field>
                                    </template>
                                    <v-time-picker 
                                        v-if="menu1" 
                                        v-model="editStartShiftData.start_time" 
                                        format="24hr"
                                        :max="
                                            !no_data.includes(items) &&
                                            !no_data.includes(items[0]) &&
                                            !no_data.includes(items[0].end_time)
                                            ? onlyTime(items[0].end_time) : ''
                                        "
                                        @change="menu1 = false"
                                    ></v-time-picker>
                                </v-menu>
                                <v-text-field
                                    label="Start Shift Notes"
                                    v-model="editStartShiftData.start_note"
                                    placeholder="Please Enter"
                                    prepend-icon="message"
                                    :error-messages="server_errors.start_note"
                                    @focus="resetServerValidation"
                                ></v-text-field>
                                <v-alert class="pa-2 mt-4" :value="$v.editStartShiftData.$error" outlined color="error" icon="priority_high" transition="scale-transition">
                                    <span class="caption">Please fill out form correctly</span>
                                </v-alert>
                                <v-alert class="pa-2 mt-4" :value="!serverValidation" outlined color="error" icon="priority_high" transition="scale-transition">
                                    <span class="caption">{{ serverValidationMessage }}</span>
                                </v-alert>
                            </div>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" text @click="closeEditStartShift">Cancel</v-btn>
                                <v-btn color="primary" :loading="saveEditStartShiftLoading" :disabled="saveEditStartShiftLoading" @click="editStartShift">Save</v-btn>
                            </v-card-actions>
                        </div>
                    </v-card>
                </v-dialog>

                <!-- Edit End Shift Info -->
                <v-dialog v-if="editEndShiftDialog" v-model="editEndShiftDialog" max-width="500px" persistent>
                    <v-card class="pa-4">
                        <div>
                            <v-card-title>
                                <h2 class="title">Edit End Shift Info</h2>
                            </v-card-title>

                            <div class="py-4 px-6">
                                <v-text-field
                                    label="Odometer Shift End"
                                    v-model="editEndShiftData.end_odometer"
                                    placeholder="Please Enter"
                                    maxlength="4"
                                    v-mask="'####'"
                                    :error-messages="errors($v.editEndShiftData.end_odometer) || server_errors.end_odometer"
                                    @blur="$v.editEndShiftData.end_odometer.$touch()"
                                    @focus="resetServerValidation"
                                ></v-text-field>
                                <v-menu
                                    ref="menu2"
                                    :close-on-content-click="false"
                                    v-model="menu2"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            class="scale-icon mb-2"
                                            v-on="on"
                                            v-model="editEndShiftData.end_time"
                                            label="End time"
                                            prepend-icon="access_time"
                                            readonly
                                            placeholder="Please Enter"
                                            :error-messages="errors($v.editEndShiftData.end_time) || server_errors.end_time"
                                            @blur="$v.editEndShiftData.end_time.$touch()"
                                            @focus="resetServerValidation"
                                        ></v-text-field>
                                    </template>
                                    <v-time-picker 
                                        v-if="menu2" 
                                        v-model="editEndShiftData.end_time" 
                                        format="24hr"
                                        :min="
                                            !no_data.includes(items) &&
                                            !no_data.includes(items[0]) &&
                                            !no_data.includes(items[0].start_time)
                                            ? onlyTime(items[0].start_time) : ''
                                        "
                                        @change="menu2 = false"
                                    ></v-time-picker>
                                </v-menu>
                                <v-text-field
                                    label="End Shift Notes"
                                    v-model="editEndShiftData.end_note"
                                    placeholder="Please Enter"
                                    prepend-icon="message"
                                    :error-messages="server_errors.end_note"
                                    @focus="resetServerValidation"
                                ></v-text-field>
                                <v-alert class="pa-2 mt-4" :value="$v.editEndShiftData.$error" outlined color="error" icon="priority_high" transition="scale-transition">
                                    <span class="caption">Please fill out form correctly</span>
                                </v-alert>
                                <v-alert class="pa-2 mt-4" :value="!serverValidation" outlined color="error" icon="priority_high" transition="scale-transition">
                                    <span class="caption">{{ serverValidationMessage }}</span>
                                </v-alert>
                            </div>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" text @click="closeEditEndShift">Cancel</v-btn>
                                <v-btn color="primary" :loading="saveEditEndShiftLoading" :disabled="saveEditEndShiftLoading" @click="editEndShift">Save</v-btn>
                            </v-card-actions>
                        </div>
                    </v-card>
                </v-dialog>
            </div>
        </div>
    </v-app>
</template>

<script>
    import ApiService from "@/common/api.service"
    import { validationMixin } from 'vuelidate'
    import { required, helpers } from 'vuelidate/lib/validators'
    import { valMessages, getValMessage } from '@/common/error-messages'
    import moment from 'moment'
    import { mask } from 'vue-the-mask'
    import BreakInfo from './BreakInfo'
    import { mapActions } from "vuex";

    let validations = {}

    export default {
        name: 'ShiftItem',
        components: {
            BreakInfo
        },
        mixins: [validationMixin],
        validations() {
            validations = {
                editStartShiftData: {
                    start_company_vehicle: { required },
                    start_odometer: { required, odometer: v => !helpers.req(v) || /^\d{4}$/.test(v) },
                    start_time: { 
                        required,
                        startTime: value => 
                            !helpers.req(value) ||
                            this.no_data.includes(this.items[0]) ||
                            this.no_data.includes(this.items[0].end_time) ||
                            moment(`${this.items[0].shift_date} ${value}`, 'YYYY-MM-DD HH:mm', true).isSameOrBefore(moment(this.items[0].end_time)),
                        beforeBreakStart: value =>
                            !helpers.req(value) ||
                            this.no_data.includes(this.breaks) ||
                            !Array.isArray(this.breaks) ||
                            this.breaks.length === 0 ||
                            this.breaks.some(i => 
                                !this.no_data.includes(i.start_time) && 
                                moment(`${this.items[0].shift_date} ${value}`, 'YYYY-MM-DD HH:mm', true)
                                .isSameOrBefore(moment(i.start_time))
                            )
                    }
                },
                editEndShiftData: {
                    end_company_vehicle: { required },
                    end_odometer: { required, odometer: v => !helpers.req(v) || /^\d{4}$/.test(v) },
                    end_time: { 
                        required,
                        endTime: value => 
                            !helpers.req(value) ||
                            this.no_data.includes(this.items[0]) ||
                            this.no_data.includes(this.items[0].start_time) ||
                            moment(`${this.items[0].shift_date} ${value}`, 'YYYY-MM-DD HH:mm', true).isSameOrAfter(moment(this.items[0].start_time)),
                        afterBreakEnd: value =>
                            !helpers.req(value) ||
                            this.no_data.includes(this.breaks) ||
                            !Array.isArray(this.breaks) ||
                            this.breaks.length === 0 ||
                            this.breaks.some(i => 
                                !this.no_data.includes(i.end_time) && 
                                moment(`${this.items[0].shift_date} ${value}`, 'YYYY-MM-DD HH:mm', true)
                                .isSameOrAfter(moment(i.end_time))
                            )
                    }
                }
            }
            this.errors = getValMessage(valMessages)(validations);
            return validations;
        },
        directives: {mask},
        data() {
            return {
                items: [],
                breaks: [],
                shift: {},
                active: null,
                active1: null,
                shift_break: [],
                loading: false,
                shift_revenue: 0,
                
                menu3: false,
                menu4: false,
                menu5: false,
                menu6: false,
                menu7: false,

                menu1: false,
                menu2: false,
                no_data: [null, '', undefined, 'null'],
                headers: [
                    { text: 'Results', value: 'results', sortable: false },
                    { text: 'Results', value: 'results', sortable: false },
                    { text: 'Results', value: 'results', sortable: false },
                    { text: 'Results', value: 'results', sortable: false }
                ],
                disableShiftTime: true,
                disableOdometer: true,
                disableBreakTime: true,
                disableShiftNotes: true,
                shiftTimeBtnText: 'Edit',
                vehicle: [
                    { text: 'Company', value: 1},    
                    { text: 'Personal', value: 0}    
                ],

                editStartShiftDialog: false,
                saveEditStartShiftLoading: false,
                editStartShiftData: {},

                editEndShiftDialog: false,
                endFormValidation: true,
                saveEditEndShiftLoading: false,
                editEndShiftData: {},
                serverValidation: true,
                serverValidationMessage: 'Oops something went wrong...',

                editBreakDialog: false,
                breakFormValidation: true,
                saveEditBreakLoading: false,
                editBreakData: {},
                breakServerValidation: true,
                breakServerValidationMessage: 'Oops something went wrong...',

                serverValidation: true,
                serverValidationMessage: 'Oops something went wrong...',
                server_errors: {}
            }
        },
        beforeMount() {
            this.getDataFromApi()
        },
        methods: {
            ...mapActions(['vEmit']),
            getDataFromApi(id = this.$route.params.id) {
                this.loading = true;
                ApiService.get('/time_and_mileage/get_shift', {shift_id: id})
                    .then(response => {
                        this.loading = false
                        if(response.data.shift !== null) {
                            this.items = [response.data.shift]
                        }
                        this.breaks = response.data.shift_breaks.reverse()
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error)
                    })
            },
            getShiftRevenue(shift_date,employee_id){
                ApiService.get('/payroll/revenue_info_employee_date', {employee_id: employee_id,date: shift_date})
                    .then(response => {
                        this.shift_revenue = response.data.revenue;
                    })
            },
            editStartShiftModal() {
                this.resetServerValidation()
                this.editStartShiftData = {
                    shift_id: this.items[0].id,
                    start_odometer: this.items[0].start_odometer,
                    start_company_vehicle: this.items[0].start_company_vehicle,
                    start_note: this.items[0].start_note,
                    start_time: this.items[0].start_time !== null ? this.onlyTime(this.items[0].start_time) : '',
                    staff_employee_id: this.items[0].employee_id,
                    staff_user_id: this.items[0].user_id
                }
                this.editStartShiftDialog = true;
                this.$v.editStartShiftData.$reset()
            },
            editStartShift() {
                this.resetServerValidation()
                this.$v.editStartShiftData.$touch()
                if(!this.$v.editStartShiftData.$invalid){
                    this.saveEditStartShiftLoading = true
                    let body = {...this.editStartShiftData}

                    ApiService.put('/time_and_mileage/update_start_shift', body)
                        .then(response => {
                            this.saveEditStartShiftLoading = false
                            this.vEmit({ 
                                name: "notification", 
                                data: {
                                    status: 'success', 
                                    text: 'Start Shift Info has been successfully edited.'
                                }
                            });
                            this.getDataFromApi();
                            this.closeEditStartShift();
                        })
                        .catch(({ response }) => {
                            this.saveEditStartShiftLoading = false
                            this.serverValidation = false
                            if (response.data.error) {
                                this.serverValidationMessage = this.titleCase(response.data.error)
                            }
                            if(response.data.message){
                                this.serverValidationMessage = response.data.message
                            }
                            if (response.data.errors) {
                                if (typeof response.data.errors === 'string') {
                                    this.serverValidationMessage = response.data.errors
                                } else {
                                    this.server_errors = response.data.errors
                                }
                            }
                        })
                }
            },
            closeEditStartShift() {
                this.editStartShiftDialog = false;
            },


            editEndShiftModal() {
                this.resetServerValidation()
                this.editEndShiftData = {
                    shift_id: this.items[0].id,
                    end_odometer: this.items[0].end_odometer,
                    end_company_vehicle: this.items[0].end_company_vehicle,
                    end_note: this.items[0].end_note,
                    end_time: this.items[0].end_time !== null ? this.onlyTime(this.items[0].end_time) : '',
                    staff_employee_id: this.items[0].employee_id,
                    staff_user_id: this.items[0].user_id
                }
                this.editEndShiftDialog = true
                this.$v.editEndShiftData.$reset()
            },
            editEndShift() {
                this.resetServerValidation()
                this.$v.editEndShiftData.$touch()
                if(!this.$v.editEndShiftData.$invalid){
                    this.saveEditEndShiftLoading = true
                    let body = {...this.editEndShiftData}

                    ApiService.put('/time_and_mileage/update_end_shift', body)
                        .then(response => {
                            this.saveEditEndShiftLoading = false
                            this.vEmit({ 
                                name: "notification", 
                                data: {
                                    status: 'success', 
                                    text: 'End Shift Info has been successfully edited.'
                                }
                            });
                            this.getDataFromApi();
                            this.closeEditEndShift();
                        })
                        .catch(({ response }) => {
                            this.saveEditEndShiftLoading = false
                            this.serverValidation = false
                            if (response.data.error) {
                                this.serverValidationMessage = this.titleCase(response.data.error)
                            }
                            if(response.data.message){
                                this.serverValidationMessage = response.data.message
                            }
                            if (response.data.errors) {
                                if (typeof response.data.errors === 'string') {
                                    this.serverValidationMessage = response.data.errors
                                } else {
                                    this.server_errors = response.data.errors
                                }
                            }
                        })
                }
            },
            closeEditEndShift() {
                this.editEndShiftDialog = false;
            },

            editBreakModal(i) {
                this.breakServerValidation = true
                this.editBreakData = {
                    shift_id: this.items[0].id,
                    shift_break_id: this.breaks[i].id,
                    start_time: this.breaks[i].start_time !== null ? this.onlyTime(this.breaks[i].start_time) : '',
                    end_time: this.breaks[i].end_time !== null ? this.onlyTime(this.breaks[i].end_time) : '',
                    start_odometer: this.breaks[i].start_odometer,
                    end_odometer: this.breaks[i].end_odometer,
                    start_note: this.breaks[i].start_note,
                    end_note: this.breaks[i].end_note,
                }
                this.editBreakDialog = true;
                this.breakFormValidation = true;
            },
            editBreak() {
                if(this.$refs.editEndShiftForm.validate()){
                    this.saveEditEndShiftLoading = true
                    let body = {...this.editEndShiftData}

                    ApiService.put('/time_and_mileage/update_end_shift', body)
                        .then(response => {
                            this.saveEditEndShiftLoading = false
                            this.vEmit({ 
                                name: "notification", 
                                data: {
                                    status: 'success', 
                                    text: 'End Shift Info has been successfully edited.'
                                }
                            });
                            this.getDataFromApi();
                            this.closeEditEndShift();
                        })
                        .catch(({ response }) => {
                            this.saveEditEndShiftLoading = false
                            this.serverValidation = false
                            if(response.data.error){
                                this.serverValidationMessage = _.upperFirst(response.data.error.replace(/_/g, ' '))
                            }
                        })
                }
            },
            closeEditBreak() {
                this.editEndShiftDialog = false;
            },


            onlyDate(date) {
                return moment(date).format('YYYY-MM-DD');
            },
            onlyTime(date) {
                return moment(date).format('HH:mm');
            },
            onlyNumbers ($event) {
                let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
                if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
                    $event.preventDefault()
                }
            },
            titleCase(str){
                return _.startCase(str.replace(/_/g, ' '));
            },
            resetServerValidation() {
                this.serverValidation = true
                this.serverValidationMessage = 'Oops something went wrong...'
                this.server_errors = {}
            },
            errors: getValMessage(valMessages)(validations)
        }
    }
</script>

<style>
    /*Layout Width*/
    .shift-layout-wrap {
        /* max-width: 900px; */
        width: 100%;
        margin: 0px auto;
    }

    /*Top Header*/
    .top-header-shift {
        margin-bottom: 40px;
    }

    .img-div-header-box {
        width: 30%;
        display: inline-block;
        height: 70px;
        background-color: lightgray;
        vertical-align: middle;
        text-align: center;
        padding: 17px 0px;
        border-top-left-radius: inherit!important;
        border-top-right-radius: 0px!important;
        border-bottom-right-radius: 0px;
        border-bottom-left-radius: inherit;
    }

    .img-div-header-box .v-icon {
        padding: 0px;
        color: white !important;
        border-top: none;
    }

    .img-header-box-name {
        background-color: lightgray;
    }

    .img-header-box-duration {
        background-color: #00BCD4;
    }

    .img-header-box-distance {
        background-color: #FF9800;
    }

    .img-header-box-renvenue {
        background-color: #4CAF50;
    }

    .title-div-header-box {
        display: inline-block;
        vertical-align: middle;
        padding-left: 10px;
        width: 70%;
    }

    .title-div-header-box p {
        font-size: x-small;
        margin: 0px;
    }

    .title-div-header-box h4 {
        font-weight: 400;
        font-size: 19px;
    }

    .title-div-header-box span {
        font-weight: 400;
        font-size: small;
    }

    /*Header*/
    .bottom-card-space {
        margin-bottom: 24px;
    }

    /*Body Cards*/
    .right-card-space {
        margin-right: 12px;
    }

    .left-card-space {
        margin-left: 12px;
    }

    .card-title-shift {
        font-weight: 400;
        font-size: medium;
    }

    .shift-cards {
        padding: 25px;
    }

    .shift-cards .v-card__title {
        padding: 5px 0px 20px 0px
    }

    .bottom-card-elem-space {
        margin-bottom: 15px;
    }

    .card-actions div {
        width: 100%;
        text-align: right;
    }

    .card-actions div .link-button .v-btn__content {
        text-decoration: none;
    }

    .scale-icon .v-input__prepend-outer,
    .img-header-box-duration .v-icon {
        -moz-transform: scaleX(-1);
        -o-transform: scaleX(-1);
        -webkit-transform: scaleX(-1);
        transform: scaleX(-1);
        filter: FlipH;
        -ms-filter: "FlipH";
    }

    .company-vehicle-label .v-label {
        font-size: smaller;
        margin: -3px -0px -14px 36px;
    }

    .shift-cards .v-label {
        font-size: smaller;
    }

    .start-note .v-input__slot {
        height: 81px;
    }

    .end-note .v-input__slot {
        height: 81px;
    }

    .shift-card-save-btn .v-btn__content {
        color: inherit;
    }

    .shift-layout-wrap .v-tabs__item {
        text-transform: none;
        padding: 6px 18px;
    }

    .shift-layout-wrap .employee-name {
        font-size: 15px;
    }
</style>
